import { useState } from 'react';
import { LegacySmallCopyIcon } from './legacy-icons';

/**
 * The vendor-order-id cell (`tableHeaderSelector.tsx:125-204`): an em-dash
 * when the merchant supplied no reference, otherwise the value as a
 * click-to-copy target that grows a grey pill on hover with a small copy
 * glyph — the same affordance the ID column carries.
 *
 * The copy click must not fall through to the row's open-drawer handler.
 */
export function LegacyVendorOrderCell({
  value,
  onCopied,
}: {
  value: string | null;
  onCopied: () => void;
}) {
  const [hovered, setHovered] = useState(false);

  if (!value) return <span>—</span>;

  return (
    <button
      type="button"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={(e) => {
        e.stopPropagation();
        void navigator.clipboard.writeText(value);
        onCopied();
      }}
      title={value}
      className={[
        'inline-flex max-w-full min-w-0 cursor-pointer items-center gap-1 overflow-hidden rounded-[20px]',
        'text-left font-medium select-none',
        'transition-all duration-150',
        hovered ? 'bg-[var(--lg-grey-100)] px-2 py-0.5' : 'bg-transparent',
      ].join(' ')}
    >
      <span className="min-w-0 flex-1 truncate">{value}</span>
      {hovered && <LegacySmallCopyIcon className="shrink-0" />}
    </button>
  );
}
